var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentTheme == 'theme-default')?_c('default-theme',{ref:"defaultHeaderPage"}):(_vm.currentTheme == 'theme-theme1')?_c('theme-theme1',{ref:"theme1HeaderPage"}):(_vm.currentTheme == 'theme-theme2')?_c('theme-theme2',{ref:"theme2HeaderPage"}):(_vm.currentTheme == 'theme-theme3')?_c('theme-theme3',{ref:"theme3HeaderPage"}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eed6192","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = null
// module chunks = 